var e = /* @__PURE__ */ ((r) => (r.Error = "error", r.Info = "info", r.Success = "success", r))(e || {});
const o = 5e3;
export {
  o as TOAST_VISIBILITY_DURATION,
  e as VariantsEnum
};
